module.exports = __webpack_public_path__ + "static/home_rect-5a01ae0d421147988c140554a3e7ce2f.png";